import type { FC } from 'react'

import { unit } from '@hcr/ui'

import { BookingList, ButtonSignOut } from '../../common'

import { BookingListEmpty, BookingListPreview, LayoutContextMenu } from './common'

export const ContextMenu: FC = () => {
  return (
    <LayoutContextMenu
      cta={<ButtonSignOut variant='outlined' color='black' sx={{ fontSize: unit(4), lineHeight: unit(6) }} />}
      list={<BookingList empty={BookingListEmpty} preview={BookingListPreview} />}
    />
  )
}
